const AddressDetails = () => {
  return (<>
    <h1>Address Details</h1>
    <input
      type="input"
      placeholder="Enter City"
    />
    <input style={{"margin-top":".5rem"}}
      type="Email"
      placeholder="Enter State"
    />
  </>) 
}

export default AddressDetails